import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { appInjector } from '../app-injector';
import { LoadModalComponent } from '../load-modal/load-modal.component';
;

@Injectable({
  providedIn: 'root'
})
export class LoadIndicatorService {
  private urlsWithoutLoadIndicator = new Array<string>();
  pendingRequests = new BehaviorSubject<number>(0);
  constructor() {
    let modal: BsModalRef;
    this.pendingRequests
      .pipe(debounceTime(100), distinctUntilChanged())
      .subscribe((pendientes) => {
        if (pendientes > 0 && !modal) {
          const modalService = appInjector.get(BsModalService);
          const subscription = modalService.onShow.subscribe(() => {
            subscription.unsubscribe();
            if (pendientes === 0) {
              modal.hide();
              modal = null;
            }
          });
          // console.log('show')
          modal = modalService.show(LoadModalComponent, {
            backdrop: true,
            ignoreBackdropClick: true,
            animated: false,
          });
        } else if (modal && pendientes === 0) {
          // console.log('hide')
          modal.hide();
          modal = null;
        }
      });
  }
  /** Registra url sin indicador de carga  */
  addURLWithoutLoadIndicator(url: string) {
    if (this.urlsWithoutLoadIndicator.indexOf(url) === -1) {
      this.urlsWithoutLoadIndicator.push(url);
    }
  }

  /** comprueba si se debe evitarel indicdor de carga al pedir una url */
  avoidLoadIndicator(url: string): boolean {
    return this.urlsWithoutLoadIndicator.indexOf(url) !== -1;
  }
}
